import React from 'react'
import { Translate } from 'react-i18nify'
import { Field } from 'formik'
import { CitySelector } from '../../CitySelector'

export const CityFormikSelector = ({ useCityName = false }) => {
    return (
        <>
            <Field name="city">
                {({ field, form, meta }) => (
                    <CitySelector
                        controller={{
                            ...field,
                            ...meta,
                            onChange: (value) => form.setFieldValue('city', value),
                        }}
                    />
                )}
            </Field>

            <label className="form__label" htmlFor="city">
                <Translate value={useCityName ? 'labels.city_name' : 'labels.city'} />
            </label>
        </>
    )
}
